<template>
  <div>
    <div class="layout">
      <div class="introduce-wrap">
        <h2 class="title">문화체육관광 국가승인통계별 공표 일정</h2>
        <div style="width:100%;overflow:hidden;overflow-x:auto;">
          <table class="stat-list-table bdr-r">
            <caption class="ir">문화체육관광 통계 현황</caption>
            <colgroup>
              <col style="width:140px;">
              <col style="width:290px;">
              <col style="width:170px;">
              <col style="width:200px;">
              <col style="width:270px;">
              <col>
            </colgroup>
            <thead>
            <tr>
              <th scope="col">분야</th>
              <th scope="col">통계명</th>
              <th scope="col">작성방법</th>
              <th scope="col">작성주기</th>
              <th scope="col">공표시기</th>
              <th scope="col">작성기관</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td rowspan="8">문화</td>
              <td>국민문화예술활동조사</td>
              <td>조사</td>
              <td>1년</td>
              <td>당년 12월</td>
              <td>문화체육관광부(문화정책과)</td>
            </tr>
            <tr>
              <td>국민여가활동조사</td>
              <td>조사</td>
              <td>1년</td>
              <td>당년 12월</td>
              <td>문화체육관광부(문화정책과)</td>
            </tr>
            <tr>
              <td>근로자휴가조사</td>
              <td>조사</td>
              <td>1년</td>
              <td>익년 12월</td>
              <td>문화체육관광부(문화정책과)</td>
            </tr>
            <tr>
              <td>문화다양성실태조사</td>
              <td>조사</td>
              <td>2년</td>
              <td>익년 2월</td>
              <td>문화체육관광부(문화정책과)</td>
            </tr>
            <tr>
              <td>전국도서관통계</td>
              <td>보고</td>
              <td>1년</td>
              <td>익년 12월</td>
              <td>문화체육관광부(도서관정책기획단)</td>
            </tr>
            <tr>
              <td>지역문화현황통계</td>
              <td>보고</td>
              <td>3년</td>
              <td>익익년 4월</td>
              <td>문화체육관광부(지역문화정책과)</td>
            </tr>
            <tr>
              <td>국민문화예술교육조사</td>
              <td>조사</td>
              <td>1년</td>
              <td>익익년 3월</td>
              <td>문화체육관광부(문화예술교육과)</td>
            </tr>
            <tr>
              <td>한국수어활용조사</td>
              <td>조사</td>
              <td>3년</td>
              <td>익년 6월</td>
              <td>국립국어원</td>
            </tr>
            <tr class="highlight">
              <td rowspan="2">예술</td>
              <td>공연예술조사</td>
              <td>조사</td>
              <td>1년</td>
              <td>익년 12월</td>
              <td>문화체육관광부(공연전통예술과)</td>
            </tr>
            <tr class="highlight">
              <td>예술인실태조사</td>
              <td>조사</td>
              <td>3년</td>
              <td>익년 5월</td>
              <td>문화체육관광부(예술인권리보호과)</td>
            </tr>
            <tr>
              <td rowspan="4">콘텐츠</td>
              <td>콘텐츠산업조사</td>
              <td>조사</td>
              <td>1년</td>
              <td>익년 2월</td>
              <td>문화체육관광부(문화산업정책과)</td>
            </tr>
            <tr>
              <td>광고산업조사</td>
              <td>조사</td>
              <td>1년</td>
              <td>익년 12월</td>
              <td>문화체육관광부(미디어정책과)</td>
            </tr>
            <tr>
              <td>국민독서실태조사</td>
              <td>조사</td>
              <td>2년</td>
              <td>익년 3월</td>
              <td>문화체육관광부(출판인쇄독서진흥과)</td>
            </tr>
            <tr>
              <td>국제문화교류실태조사</td>
              <td>조사</td>
              <td>3년</td>
              <td>익익년 12월</td>
              <td>문화체육관광부(국제문화정책과)</td>
            </tr>
            <tr class="highlight">
              <td rowspan="4">관광</td>
              <td>주요관광지점 입장객통계</td>
              <td>보고</td>
              <td>매월</td>
              <td>분기 익익월 잠정치<br>년 익년 6월 확정치</td>
              <td>문화체육관광부(관광정책과)</td>
            </tr>
            <tr class="highlight">
              <td>국민여행조사</td>
              <td>조사</td>
              <td>1년</td>
              <td>분기 6월, 9월, 12월, 익년 3월,<br>잠정치 익년 6월 확정치</td>
              <td>문화체육관광부(관광정책과)</td>
            </tr>
            <tr class="highlight">
              <td>외래관광객조사</td>
              <td>조사</td>
              <td>1년</td>
              <td>익년 5월</td>
              <td>문화체육관광부(국제관광정책과)</td>
            </tr>
            <tr class="highlight">
              <td>관광산업조사</td>
              <td>조사</td>
              <td>1년</td>
              <td>익년 12월</td>
              <td>문화체육관광부(관광산업진흥과)</td>
            </tr>
            <tr>
              <td rowspan="5">체육</td>
              <td>체육인실태조사</td>
              <td>조사</td>
              <td>2년</td>
              <td>익년 7월</td>
              <td>문화체육관광부(스포츠인권복지과)</td>
            </tr>
            <tr>
              <td>국민생활체육조사</td>
              <td>조사</td>
              <td>1년</td>
              <td>익년 1월</td>
              <td>문화체육관광부(체육진흥과)</td>
            </tr>
            <tr>
              <td>국민체력측정통계</td>
              <td>보고</td>
              <td>1년</td>
              <td>익익년 4월</td>
              <td>문화체육관광부(체육진흥과)</td>
            </tr>
            <tr>
              <td>장애인생활체육조사</td>
              <td>조사</td>
              <td>1년</td>
              <td>익년 1월</td>
              <td>문화체육관광부(장애인체육과)</td>
            </tr>
            <tr>
              <td>스포츠산업조사</td>
              <td>조사</td>
              <td>1년</td>
              <td>익익년 1월</td>
              <td>문화체육관광부(스포츠산업과)</td>
            </tr>
            <tr class="highlight">
              <td rowspan="1">종합</td>
              <td>문화체육관광일자리현황조사</td>
              <td>조사</td>
              <td>분기</td>
              <td>당년 11월, 익년 5월<br>※ 2026년에 한하여 9월말 공표예정</td>
              <td>문화체육관광부(기획혁신담당관)</td>
            </tr>
            </tbody>
          </table>
        </div>
        <p class="title-info-txt" style="padding: 15px 0 24px 0;">
          ※ 통계표 공표 일정은 변경될 수 있습니다.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'McstScheduleInfo'
}
</script>

<style scoped>
@media only screen and (max-width: 768px){
  .stat-list-table thead tr th, .stat-list-table tbody tr td{
    font-size:13px !important;
    -webkit-text-size-adjust: none !important;
    text-size-adjust: none !important;
  }
  .stat-list-table p{
    font-size: 13px !important;
    -webkit-text-size-adjust: none !important;
    text-size-adjust: none !important;
  }
}

.stat-list-table {
  border-collapse: collapse;
}

.stat-list-table tr.highlight > td {
  background-color: #F9F9F9;
}

</style>

